module.exports = "/images/vendor/flag-icon-css/flags/4x3/in.svg?e4ab7bd057c6d49f21b3460a1bf914a9";